module.exports = __webpack_public_path__ + "img/专利证书04_厂房分项能耗数据采集与传输软件v1.0.2ec4fe93.png";